import { Node } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-2";
import FileAttach from "./FileAttach.vue";

export default Node.create({
  name: "fileattach",

  group: "block",
  content: "text*",

  defining: true,

  addAttributes() {
    return {
      src: {
        default: null
      }
    };
  },

  addCommands() {
    return {
      setFileAttach: attributes => ({ chain }) => {
        return chain()
          .setNode(this.name, attributes)
          .run();
      },

      toggleFileAttach: attributes => ({ chain }) => {
        return chain()
          .toggleNode(this.name, attributes)
          .run();
      },

      unsetFileAttach: () => ({ chain }) => {
        return chain()
          .toggleNode(this.name, "paragraph")
          .run();
      }
    };
  },

  parseHTML() {
    return [
      {
        tag: "file-attach[src]"
      }
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["file-attach", HTMLAttributes, 0];
  },

  addNodeView() {
    return VueNodeViewRenderer(FileAttach);
  }
});
